const TEMP_ALWAYS_ALLOWED_PREFIXES = ["/permissoes/permissao-de-usuarios"];

function pathMatchesPrefix(pathname: string, prefix: string): boolean {
  const normalizedPrefix = prefix.startsWith("/") ? prefix : `/${prefix}`;
  if (pathname === normalizedPrefix) return true;
  return pathname.startsWith(
    normalizedPrefix.endsWith("/") ? normalizedPrefix : `${normalizedPrefix}/`,
  );
}

function flattenToPaths(items: any[]): string[] {
  const paths: string[] = [];
  for (const menu of items || []) {
    if (menu?.to) paths.push(menu.to);
    for (const child of menu?.childrens || []) {
      if (child?.to) paths.push(child.to);
    }
  }
  return paths;
}

export function isRouteAllowed(
  pathname: string,
  permittedMenuItems: any[],
  allMenuItems: any[],
): boolean {
  if (TEMP_ALWAYS_ALLOWED_PREFIXES.some((prefix) => pathMatchesPrefix(pathname, prefix))) {
    return true;
  }

  const allPaths = flattenToPaths(allMenuItems);

  let matchedPath: string | null = null;
  for (const to of allPaths) {
    if (pathMatchesPrefix(pathname, to)) {
      if (!matchedPath || to.length > matchedPath.length) {
        matchedPath = to;
      }
    }
  }

  if (!matchedPath) {
    return true;
  }

  const permittedPaths = flattenToPaths(permittedMenuItems);
  return permittedPaths.includes(matchedPath);
}
